import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import {
  useAddPermissionManagementMutation,
  useDeletePermissionManagementMutation,
  useGetPermissionManagementsQuery,
} from "../../../Service/permissionManagement";
import { Box, Button, Grid } from "@mui/material";
import Toast from "../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import PermissionCheck from "../../../Component/PermissionCheck";
import { useSelector } from "react-redux";

export default function Permissions(props) {
  const { modules, permissions, id, add, deselect } = props;
  const { data: PermissionsManagementResponse } =
    useGetPermissionManagementsQuery(id);
  const { open, message, openSnackBar, type } = useSnackbar();
  const [createRelation, setCreateRelation] = React.useState([]);
  const [deleteRelation, setDeleteRelation] = React.useState([]);
  const [permissionData, setPermissionData] = React.useState(null);
  // console.log(permissionData);

  const [addPermissionManagement, { isLoading: isloading }] =
    useAddPermissionManagementMutation();
  const [deletePermissionManagement, { isLoading: isdeleteloading }] =
    useDeletePermissionManagementMutation();
  React.useEffect(() => {
    if (PermissionsManagementResponse) {
      setPermissionData(PermissionsManagementResponse);
    }
  }, [PermissionsManagementResponse]);

  React.useEffect(() => {
    // console.log(add);
    if (add||deselect) {
      collectAllIds();
    }
    // console.log(deselect);
    // console.log(createRelation);
  }, [props]);

  const onCheck = (moduleId, permissionId, event) => {
    // console.log(moduleId, permissionId);

    const { checked } = event.target;
    // console.log(checked);

    if (checked) {
      if (
        !isThere(moduleId, permissionId, PermissionsManagementResponse) &&
        !isThere(moduleId, permissionId, createRelation)
      ) {
        setCreateRelation((prev) => [
          ...prev,
          {
            permissionId,
            moduleId,
            roleId: id,
          },
        ]);
      }
      if (isThere(moduleId, permissionId, deleteRelation)) {
        setDeleteRelation((prev) => [
          ...prev.filter(
            (item) =>
              !(
                item.permissionId === permissionId && item.moduleId === moduleId
              )
          ),
        ]);
      }
    } else {
      if (
        isThere(moduleId, permissionId, PermissionsManagementResponse) &&
        !isThere(moduleId, permissionId, deleteRelation)
      ) {
        setDeleteRelation((prev) => [
          ...prev,
          {
            permissionId,
            moduleId,
            roleId: id,
          },
        ]);
      }
      if (isThere(moduleId, permissionId, createRelation)) {
        setCreateRelation((prev) => [
          ...prev.filter(
            (item) =>
              !(
                item.permissionId === permissionId && item.moduleId === moduleId
              )
          ),
        ]);
      }
    }
  };
  const onCheckAll = (moduleId, permissionId, checked) => {
    // console.log(moduleId, permissionId);

    if (checked) {
      if (
        !isThere(moduleId, permissionId, PermissionsManagementResponse) &&
        !isThere(moduleId, permissionId, createRelation)
      ) {
        setCreateRelation((prev) => [
          ...prev,
          {
            permissionId,
            moduleId,
            roleId: id,
          },
        ]);
        // console.log("added");
      }
      if (isThere(moduleId, permissionId, deleteRelation)) {
        setDeleteRelation((prev) => [
          ...prev.filter(
            (item) =>
              !(
                item.permissionId === permissionId && item.moduleId === moduleId
              )
          ),
        ]);
      }
    } else {
      if (
        isThere(moduleId, permissionId, PermissionsManagementResponse) &&
        !isThere(moduleId, permissionId, deleteRelation)
      ) {
        setDeleteRelation((prev) => [
          ...prev,
          {
            permissionId,
            moduleId,
            roleId: id,
          },
        ]);
      }
      if (isThere(moduleId, permissionId, createRelation)) {
        setCreateRelation((prev) => [
          ...prev.filter(
            (item) =>
              !(
                item.permissionId === permissionId && item.moduleId === moduleId
              )
          ),
        ]);
      }
    }
  };
  const collectAllIds = () => {
    const moduleIds = modules.map((module) => module.id);
    const permissionIds = permissions.map((permission) => permission.id);

    for (const moduleId of moduleIds) {
      for (const permissionId of permissionIds) {
        if (add) {
          onCheckAll(moduleId, permissionId, true);
        } else {
          onCheckAll(moduleId, permissionId, false);
        }
        // console.log(moduleId, permissionId);

        // console.log(createRelation);
        // console.log(deleteRelation);
        // console.log(
        //   (isThere(moduleId, permissionId, permissionData)
        //    ) 
        // );
        // console.log(
        //   (
        //     isThere(moduleId, permissionId, createRelation)) 
        // );
        // console.log(
          
        //     isThere(moduleId, permissionId, deleteRelation)
        // );
        // console.log(
        //   (isThere(moduleId, permissionId, permissionData) ||
        //     isThere(moduleId, permissionId, createRelation)) 
        // );
        // console.log(
        //   (isThere(moduleId, permissionId, permissionData) ||
        //     isThere(moduleId, permissionId, createRelation)) &&
        //     isThere(moduleId, permissionId, deleteRelation)
        // );
      }
    }
  };
  const onSave = async () => {
    // console.log("save", createRelation, deleteRelation);
    await createRelation.map((item) => addPermissionManagement({ ...item }));
    await deleteRelation.map((item) => deletePermissionManagement({ ...item }));
    openSnackBar("Saved successfully");
    setCreateRelation([]);
    setDeleteRelation([]);
  };
  const account = useSelector((state: any) => state.auth);

  const isThere = (moduleId, permissionId, objects) => {
    // console.log(moduleId, permissionId);

    if (
      objects && objects.find(
        (item) => item.moduleId == moduleId && item.permissionId == permissionId
      )
    ) {
      return true;
    }
    return false;
  };
  React.useEffect(() => {
    // console.log(
    //   (isThere(1, 3, permissionData)
    //    ) 
    // );
    // console.log(
    //   (
    //     isThere(1, 3, createRelation)) 
    // );
    // console.log(
      
    //     isThere(1, 3, deleteRelation)
    // );
    // console.log(
    //   (isThere(1, 3, permissionData) ||
    //     isThere(1, 3, createRelation)) 
    // );
    // console.log(
    //   (isThere(1, 3,permissionData) ||
    //     isThere(1, 3, createRelation)) ||
    //     !isThere(1, 3, deleteRelation)
    // );
  }, [createRelation, deleteRelation]);

  return (
    <>
      {id ? (
        <Box
          sx={{ flexGrow: 1, marginTop: 5, paddingLeft: 5, paddingRight: 5 }}
        >
          <Toast open={open} type={type} message={message} />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {modules &&
              permissionData &&
              modules.map((item, index) => {
                // console.log(item);

                if (
                  item.moduleName === "ivf_journey_stages" &&
                  account.permissions.ivf_journey_status === 0
                ) {
                  return;
                }
                if (
                  item.moduleName === "medicine_master" &&
                  account.permissions.ivf_journey_status === 0
                ) {
                  return;
                }
                return (
                  <>
                    <Grid item xs={2} sm={4} md={4} key={index}>
                      <FormControl component="fieldset">
                        <>
                          <FormLabel
                            style={{
                              fontSize: 16,
                              fontWeight: "600",
                              textTransform: "capitalize",
                            }}
                            component="legend"
                            key={index}
                          >
                            {item?.moduleTitle}
                          </FormLabel>
                          <FormGroup aria-label="position" row>
                            {permissions &&
                              permissions.map((permission) => (
                                <FormControlLabel
                                  value="end"
                                  control={
                                    <Checkbox
                                      checked={
                                        (isThere(
                                          item.id,
                                          permission.id,
                                          permissionData
                                        ) ||
                                          isThere(
                                            item.id,
                                            permission.id,
                                            createRelation
                                          )) &&
                                        !isThere(
                                          item.id,
                                          permission.id,
                                          deleteRelation
                                        )
                                      }
                                      onChange={(e) =>
                                        onCheck(item.id, permission.id, e)
                                      }
                                    />
                                  }
                                  label={permission.permissionName}
                                  labelPlacement="end"
                                />
                              ))}
                          </FormGroup>
                        </>
                      </FormControl>
                    </Grid>
                  </>
                );
              })}
          </Grid>
          {PermissionCheck("user_management", "add") && (
            <Button
              onClick={onSave}
              disabled={isloading || isdeleteloading}
              className="mb-3"
              variant="contained"
              style={{ height: "40px", float: "right" }}
              id="btn"
            >
              {isloading || isdeleteloading ? "Wait" : "Update"}
            </Button>
          )}
        </Box>
      ) : (
        <></>
      )}
    </>
  );
}
